module.exports = __webpack_public_path__ + "img/6.82ca3f94.jpg";